/*
 * File: SocialEngagementCard.tsx
 * Project: a-a
 * File Created: Tuesday, 19th November 2024 8:03:45 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 21st July 2025 12:31:56 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomCard from '../../../CustomCard/CustomCard';
import zeplinColor from '../../../../../theme/Color';
import { Box, Chip, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import { LightTooltip } from '../../../CustomTooltip/CustomTooltip';
import { Link } from 'react-router-dom';
import styles from './SocialEngagementCard.module.css';
const SocialEngagementCard = ({
  data,
  index,
  loading = false,
}: {
  data: any;
  index: number;
  loading?: boolean;
}) => {
  // console.log(data);
  // const { averageViews, changePercent, monthlyEngagement, totalFollowers } = data;
  const accountName = data?.accountName?.split(' ');
  const theme = useTheme();
  return (
    <CustomCard
      className={styles['socialEngagementCard']}
      styles={{
        marginTop: '16px',
        borderRadius: '14px',

        backgroundColor: zeplinColor.Neutral3,
        border: `0px solid ${zeplinColor.Neutral6}`,
        display: 'flex',

        // flex: 1,
        width: '100%',
        // height: '98px',
        ...(data?.totalFollowers && {
          '&:hover': { border: `1px solid ${zeplinColor.BasicBlack}` },
        }),
        // alignItems: 'center',
        // flexDirection: 'column',
        // justifyContent: 'space-between',
      }}
    >
      {/* <img src='/assets/user-action.svg' width={68} height={68} style={{ objectFit: 'fill' }} /> */}
      {/* <Box
        sx={{
          borderRadius: '14px',
          // padding: '10px',
          width: '68px',
          height: '68px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          gap: '10px',
          backgroundColor:
            (index + 1) % 3 === 1
              ? zeplinColor.Blue3
              : index % 3 === 2
              ? zeplinColor.Green1
              : zeplinColor.Brand1,
        }}
      >
        <Typography variant='display5' color={zeplinColor.Neutral1} sx={{ textAlign: 'center' }}>
          {accountName.map((value: any, index: number) =>
            index === 0 || index === accountName.length - 1 ? value[0] : '',
          )}
        </Typography>
      </Box> */}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '6px', xl: '12px' },
          flex: 1,

          //   padding: '2px',
          //   alignItems: 'center',
          //   justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            // height: '68px',
            alignItems: 'center',
            gap: { xs: '24px', xl: '24px' },
            textAlign: 'left',
          }}
        >
          <LightTooltip
            title={
              <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                Key Performance
              </Typography>
            }
            placement='bottom-end'
            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '100%',
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant='responsiveBody2'>Key Performance</Typography>
            )}
          </LightTooltip>

          {/* <Box
            sx={{
              display: 'flex',
              // justifyContent: 'space-between',
              // height: '68px',
              alignItems: 'center',
              gap: '8px',
              textAlign: 'left',
            }}
          >
            
          </Box> */}
          {/* {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '100%',
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Chip
              label={
                <Typography
                  variant='label1'
                  color={zeplinColor.Neutral1}
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  +12.5
                </Typography>
              }
              sx={{
                backgroundColor: zeplinColor.Green2,
                padding: '4px 8px 4px 8px',
                borderRadius: '50px',
                // width: '47px',
                height: '24px',
              }}
            />
          )} */}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '100%',
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant='responsiveH1' style={{ textAlign: 'left' }}>
                {data?.totalFollowers || 'N/A'}
              </Typography>
            )}
            <Typography
              variant='responsiveLabel1'
              color={zeplinColor.Neutral8}
              sx={{ textWrap: 'nowrap', whiteSpace: 'nowrap' }}
            >
              Total Followers
            </Typography>
          </Box>
          <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, borderWidth: 1, height: '20px' }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '100%',
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant='responsiveH1' style={{ textAlign: 'left' }}>
                {data?.monthlyEngagement || 'N/A'}
              </Typography>
            )}
            <Typography
              variant='responsiveLabel1'
              color={zeplinColor.Neutral8}
              sx={{ textWrap: 'nowrap', whiteSpace: 'nowrap' }}
            >
              Monthly Engagement
            </Typography>
          </Box>
          <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, borderWidth: 1, height: '20px' }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            {loading ? (
              <Skeleton
                variant='text'
                sx={{
                  fontSize: theme.typography.body2,
                  width: '100%',
                  // Optionally adjust other styles here
                }}
              />
            ) : (
              <Typography variant='responsiveH1' style={{ textAlign: 'left' }}>
                {data?.averageViews || 'N/A'}
              </Typography>
            )}
            <Typography
              variant='responsiveLabel1'
              color={zeplinColor.Neutral8}
              sx={{ textWrap: 'nowrap', whiteSpace: 'nowrap' }}
            >
              Average Views
            </Typography>
          </Box>
          {/* <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, borderWidth: 1, height: '20px' }}
          /> */}
        </Box>
      </Box>
    </CustomCard>
  );
};

export default SocialEngagementCard;
